// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"344a822f","963":"a826d3c9"}[chunkId] + ".chunk.js";
};